import { css } from '@emotion/react'
import "focus-visible/dist/focus-visible"

import { mediaStyle } from '../contexts/responsive'

export default css`
  html {
    height: 100%;
  }
  body {
    min-width: 100%;
    height: 100%;
  }
  #___gatsby {
    min-height: 100%;
    display: flex;
    flex-direction: column;

    > div:first-of-type {
      flex: 1;
      display: flex;
      flex-direction: column;
      > div:not(.fresnel-container) {
        flex: 1;
      }
    }
  }
  input[type=file].chakra-input {
    padding-top: 0.25em;
  }
  footer a.footer-waiting-list {
    color: var(--chakra-colors-custom-primary);
    text-decoration: underline;
  }
  ${mediaStyle}
`;
